const isProduction = process.env.NODE_ENV === 'production';
const isDocker = process.env.IS_DOCKER === 'true';

export const BASE_URL = isProduction || isDocker
  ? 'https://apps.widgets-tema.ru/checklists'
  // : 'http://localhost:89/checklists';
  : 'https://apps.widgets-tema.ru/checklists';



export const AUTH_HEADERS = {
    Authorization: `Bearer ${AMOCRM.constant("user").uuid}`,
    "Content-Type": "application/json",
    "X-User-Id": AMOCRM.constant("user").id,
    "X-User-Name": encodeURIComponent(AMOCRM.constant("user").name)
};
